// extracted by mini-css-extract-plugin
export default {"segmented":"styles_segmented__P-7UM","valueList":"styles_value-list__AepkN","dragging":"styles_dragging__5Ud2Y","draggingOver":"styles_dragging-over__jmGPr"};